export default __webpack_public_path__ + "static/media/sell.fc436aaa.png";